/*
 * LoadMore Messages
 *
 * This contains all the text for the LoadMore component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: 'app.components.PrimaryAction.Cancel',
    defaultMessage: 'Cancel',
  },
  submit: {
    id: 'app.components.PrimaryAction.Submit',
    defaultMessage: 'Submit',
  },
  save: {
    id: 'app.components.PrimaryAction.Save',
    defaultMessage: 'Save',
  },
});
